import React from "react";
import { Container, Grid } from "@mui/material";
import WelcomeCard from "../CMS/WelcomeCard";
import MyResourcesCard from "./Resource/MyResourcesCard";
import MyActivitiesCard from "./Activity/MyActivitiesCard";
import BreadcrumbBuilder from "./BreadcrumbBuilder";
import MyPDPsCard from "./PDP/MyPDPsCard";

const Dashboard = () => {
    return (
        <Container className="content">
            <Grid container spacing={3} className="card-grid">
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                <Grid item xs={12}>
                    <WelcomeCard appCode={"PORT"} />
                </Grid>

                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    xl={4}
                    className="card-grid-item"
                >
                    <MyActivitiesCard />
                </Grid>

                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    xl={4}
                    className="card-grid-item"
                >
                    <MyResourcesCard />
                </Grid>

                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    xl={4}
                    className="card-grid-item"
                >
                    <MyPDPsCard />
                </Grid>
            </Grid>
        </Container>
    );
};

export default Dashboard;
